<template>
  <inventoryProductsList/>
</template>
<script>
import inventoryProductsList from '@/components/modules/inventory/products/list'
export default {
  name: 'inventoryProducts',
  components: {
    inventoryProductsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/list.vue